import classNames from "classnames";
import { NumberInput } from "../../../components/numberInput/numberInput";
import { Input } from "../../../components/input/input";

import styles from "./editTest.module.css";

import { Text } from "../../../components/text/text";

export const InputBlock = ({ type, title, value, setValue, className, min, max, error, editor }) => {
    return (
        <div className={classNames(styles.input_block, className)}>
            <Text as="div" variant="h3" className={styles.input_block_title} size={14} weight={400} lineHeight="1">
                {title}
            </Text>
            {type === "number" && <NumberInput error={error} val={value} setVal={setValue} min={min} max={max} />}
            {type === "textEditor" && editor}
            {type !== "number" && type !== "textEditor" && <Input error={error} type={type} value={value} setValue={setValue} />}
        </div>
    )
}
